import { Lock } from "components/icons/generated";
import SearchHighlight from "components/SearchHighlight";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableCellLink from "ds/components/Table/Row/CellLink";
import Tooltip from "ds/components/Tooltip";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { isRootSpace } from "utils/space";
import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";
import { isPredefinedSpace } from "views/Account/Spaces/utils";

import { SPACE_TREE_LIST_ROOT_SPACE_USERFLOW_ID } from "../../constants";
import { SpacesListContext } from "../Context";
import SpacesListTreeCell from "./TreeCell";

const SpacesListNameCell = ({
  item: node,
  ...cellProps
}: TableSimpleCellProps<TreeNode<SpaceWithParentAccessLevel>>) => {
  const { isRootAdmin, searchQuery } = useTypedContext(SpacesListContext);

  return (
    <SpacesListTreeCell item={node} {...cellProps} role="rowheader">
      <Box gap="medium" align="center">
        <TableCellLink
          href={`/spaces/${node.id}`}
          data-userflow-id={
            isRootSpace(node.id) ? SPACE_TREE_LIST_ROOT_SPACE_USERFLOW_ID : undefined
          }
        >
          {searchQuery ? (
            <SearchHighlight fullText={node.name} searchQuery={searchQuery} />
          ) : (
            node.name
          )}
        </TableCellLink>
        {isPredefinedSpace(node.id) && isRootAdmin && (
          <Tooltip mode="parent" on={(tooltipProps) => <Icon {...tooltipProps} src={Lock} />}>
            This space is not editable.
          </Tooltip>
        )}
      </Box>
    </SpacesListTreeCell>
  );
};

export default SpacesListNameCell;
